import { merge } from '../../helper';

import isEmptyArray from '../../general/isEmpty/isEmptyArray';

import * as exModal from '../../components/modal';

import { xhr } from './xhr';
import { ajax } from './ajax';

// ----------------------------------------------------------------------------

function send(config: Record<string, any> = {}): void {
    //
    const src: Record<string, any> = {
        takeStart: 0,
        takeEnd: 0,
        response: [],
        config: {
            ajax: true,
            method: 'POST',
            upload: true,
            limit: 50,
        },
    };

    // --------------------------------------------------------------------

    function init(): void {
        // Merge
        merge(src.config, config);

        // ----------------------------------------------------------------

        // Get data
        src.data = src.config.data;

        // If there is no data
        if (isEmptyArray(src.data)) {
            console.error('The data is empty...');
            return;
        }

        // Get data length
        src.dataLength = src.config.dataLength || src.config.data.length;

        // If there is no data length
        if (!src.dataLength) {
            console.error('The data length is empty...');
            return;
        }

        // ----------------------------------------------------------------

        // Start
        start();
    }

    // --------------------------------------------------------------------

    function start(): void {
        // If using function started
        if (typeof src.config.fnStarted === 'function') {
            src.config.fnStarted();
        }
        // Is default
        else {
            // Modal Progress (Start)
            exModal.progress.start();
        }

        // Function Done
        src.config.fnDone = function (data, status, xhr): any {
            done(data, status, xhr);
        };

        // ----------------------------------------------------------------

        // Read
        read();
    }

    function read(): void {
        // Init
        src.takeEnd = src.takeStart + src.config.limit;

        // If data is less than take end
        if (src.dataLength < src.takeEnd) {
            src.takeEnd = src.dataLength;
        }

        // If using function read
        if (typeof src.config.fnRead === 'function') {
            src.config.data = src.config.fnRead(src.data, src.takeStart, src.takeEnd);
        }

        // If there is no data
        if (isEmptyArray(src.data)) {
            console.warn('The data is empty...');
            return;
        }

        // Update take start
        src.takeStart = src.takeEnd;

        // ----------------------------------------------------------------

        // If using ajax
        if (src.config.ajax === true) {
            src.request = ajax(src.config);
        }
        // Is default
        else {
            src.request = xhr(src.config);
        }
    }

    function done(data: any, status: string, xhr: any): void {
        // Response Push
        src.response.push(data);

        // ----------------------------------------------------------------

        // Percent
        const percent = Math.round((src.takeStart / src.dataLength) * 100);

        // If using function progress updated
        if (typeof src.config.fnProgressUpdated === 'function') {
            src.config.fnProgressUpdated(percent);
        }
        // Is default
        else {
            // Modal Progress (Update)
            exModal.progress.update(percent);
        }

        // ----------------------------------------------------------------

        // If the total load is not complete, send part of what is missing
        if (src.takeStart < src.dataLength) {
            read();
        }
        // If the full load is complete
        else {
            // If using function progress success
            if (typeof src.config.fnProgressSuccess === 'function') {
                src.config.fnProgressSuccess();
            }
            // If default
            else {
                // Modal Progress (Stop)
                exModal.progress.stop();

                // Modal Validation
                exModal.validation({
                    type: 'success',
                });
            }

            // If using function completed
            if (typeof src.config.fnCompleted === 'function') {
                src.config.fnCompleted(src.response[src.response.length - 1], src.response);
            }
        }
    }

    // --------------------------------------------------------------------

    init(); // Ready
}

// ------------------------------------------------------------------------

export { send };
